export const DELETE_ORGANIZATION_POINT_OF_CONTACT_MODAL_NAME =
  'DELETE_ORGANIZATION_POINT_OF_CONTACT_MODAL_NAME';
